module.exports = __webpack_public_path__ + "media/images/shared/border_stripe-2aad83b7eec89cd9ff780d7a35f962a4.png";